import { AreaSeries } from 'react-stockcharts/lib/series';
import React from 'react';

import { GradientConfig } from './ChartConfig';

export default function(props) {
  const { theme } = props;
  const canvasGradient = GradientConfig[theme].gradient;
  const strokeColor = GradientConfig[theme].strokeColor;

  return (
    <AreaSeries
      stroke={strokeColor}
      yAccessor={props.yAccessor}
      strokeWidth={1}
      canvasGradient={canvasGradient}
    />
  );
}
